import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RewardSettings = () => {
  const [loading, setLoading] = useState(true);
  const [planData, setPlanData] = useState(null);
  const [rewardData, setRewardData] = useState({
    income_type: "fix",
    status: 1,
    rewards: [],
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [editData, setEditData] = useState({
    rank_name: "",
    royalty_income: {
      team_required_business: 0,
      team_required: 0,
      team_rank_required: 0,
      investment_required: 0,
    },
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchPlanData();
  }, []);

  const fetchPlanData = async () => {
    try {
      setLoading(true);
      const response = await apiCall("POST", "/get-plan-id", { planId: 1 });
      
      // Handle response - check if data is nested or direct
      const planData = response.data?.data || response.data;
      
      if (planData) {
        setPlanData(planData);
        if (planData.reward) {
          setRewardData({
            income_type: planData.reward.income_type || "fix",
            status: planData.reward.status !== undefined ? planData.reward.status : 1,
            rewards: planData.reward.rewards || [],
          });
        }
      }
    } catch (error) {
      console.error("Error fetching plan data:", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index) => {
    const reward = rewardData.rewards[index];
    setSelectedIndex(index);
    setEditData({
      rank_name: reward.rank_name || "",
      royalty_income: {
        team_required_business: reward.royalty_income?.team_required_business || 0,
        team_required: reward.royalty_income?.team_required || 0,
        team_rank_required: reward.royalty_income?.team_rank_required || 0,
        investment_required: reward.royalty_income?.investment_required || 0,
      },
    });
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedIndex(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setEditData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: type === "checkbox" ? (checked ? 1 : 0) : (type === "number" ? parseFloat(value) || 0 : value),
        },
      }));
    } else {
      setEditData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? (checked ? 1 : 0) : (type === "number" ? parseFloat(value) || 0 : value),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!planData || !planData.planId) {
      toast.error("Plan ID not found");
      return;
    }

    try {
      setSaving(true);
      const updatedRewards = rewardData.rewards.map((item, index) => {
        if (index === selectedIndex) {
          return {
            ...item,
            rank_name: editData.rank_name,
            royalty_income: {
              ...item.royalty_income,
              team_required_business: editData.royalty_income.team_required_business,
              team_required: editData.royalty_income.team_required,
              team_rank_required: editData.royalty_income.team_rank_required,
              investment_required: editData.royalty_income.investment_required,
            },
          };
        }
        return item;
      });

      const existingReward = planData.reward || {};
      const payload = {
        planId: planData.planId,
        reward: {
          ...existingReward,
          income_type: rewardData.income_type,
          status: rewardData.status,
          rewards: updatedRewards,
        },
      };

      const response = await apiCall("POST", "/update-plan", payload);
      
      if (response.data) {
        toast.success(response.data.message || "Updated successfully");
        handleClose();
        fetchPlanData(); // Refresh data
      }
    } catch (error) {
      console.error("Error updating:", error);
      toast.error(error?.error?.message || "Failed to update");
    } finally {
      setSaving(false);
    }
  };


  if (loading) {
    return (
      <Container>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <p>Loading...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div style={{ padding: "20px" }}>
        <div style={{ marginBottom: "20px" }}>
          <h2 style={{ margin: 0 }}>Reward Settings</h2>
        </div>

        {rewardData.rewards.length > 0 ? (
          <div id="directIncomeDiv">
            <Row id="directTableRow" className="text-center">
              <Col md="12" className="p-0">
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <table style={{ minWidth: "auto", width: "100%" }}>
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Rank Name</th>
                        <th>Team Rank Required</th>
                        <th>Team Required</th>
                        <th>Team Required Business</th>
                        <th>Investment Required</th>
                        <th>Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rewardData.rewards.map((reward, index) => (
                        <tr key={index}>
                          <td data-label="S.No.">{index + 1}</td>
                          <td data-label="Rank Name">{reward.rank_name || "N/A"}</td>
                          <td data-label="Team Rank Required">{reward.royalty_income?.team_rank_required || 0}</td>
                          <td data-label="Team Required">{reward.royalty_income?.team_required || 0}</td>
                          <td data-label="Team Required Business">{reward.royalty_income?.team_required_business || 0}</td>
                          <td data-label="Investment Required">{reward.royalty_income?.investment_required || 0}</td>
                          <td data-label="Edit">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleEdit(index)}
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <p>No reward data found</p>
        )}

        {/* Edit Modal */}
        <Modal show={showModal} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              Edit Reward - {selectedIndex !== null ? rewardData.rewards[selectedIndex]?.rank_name : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Rank Name</Form.Label>
                <Form.Control
                  type="text"
                  name="rank_name"
                  value={editData.rank_name}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <hr />
              <h5>Royalty Income</h5>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Investment Required</Form.Label>
                    <Form.Control
                      type="number"
                      name="royalty_income.investment_required"
                      value={editData.royalty_income.investment_required}
                      onChange={handleInputChange}
                      step="0.01"
                      min="0"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Team Rank Required</Form.Label>
                    <Form.Control
                      type="number"
                      name="royalty_income.team_rank_required"
                      value={editData.royalty_income.team_rank_required}
                      onChange={handleInputChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Team Required</Form.Label>
                    <Form.Control
                      type="number"
                      name="royalty_income.team_required"
                      value={editData.royalty_income.team_required}
                      onChange={handleInputChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Team Required Business</Form.Label>
                    <Form.Control
                      type="number"
                      name="royalty_income.team_required_business"
                      value={editData.royalty_income.team_required_business}
                      onChange={handleInputChange}
                      step="0.01"
                      min="0"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={saving}>
                  {saving ? "Saving..." : "Save Changes"}
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </Container>
  );
};

export default RewardSettings;
